/* tslint:disable */
const TRANSLATIONS: any = {
  "i18n.additionalProducts.addToCart": "Adicionar à encomenda",
  "i18n.additionalProducts.emotionalHook": "♥️ Popular:",
  "i18n.additionalProducts.productDescription": "Descrição do produto",
  "i18n.additionalProducts.showMore": "Mais informações",
  "i18n.additionalProducts.title": "Acessórios adequados",
  "i18n.button.addToCart": "Adicionar ao carrinho",
  "i18n.button.cropImage": "",
  "i18n.button.apply": "Aplicar",
  "i18n.button.back": "Voltar",
  "i18n.button.cancel": "Cancelar",
  "i18n.button.cancelAndFix": "",
  "i18n.button.cancelAndAddImage": "",
  "i18n.button.close": "Fechar",
  "i18n.button.continue": "Continuar",
  "i18n.button.ignore": "Ignorar",
  "i18n.button.ignoreAndContinue": "Continuar na mesma",
  "i18n.button.ignoreAndContinueOrder": "",
  "i18n.button.mobile.createNewTextPlaceholders": "Texto",
  "i18n.button.noChanges": "sem alteração",
  "i18n.button.design": "",
  "i18n.button.photos": "Fotos",
  "i18n.button.retry": "Tentar novamente",
  "i18n.button.uploadPhotos": "Carregar fotos",
  "i18n.button.withSmartSorted": "Com SMART SORTED",
  "i18n.button.withoutSmartSorted": "Sem SMART SORTED",
  "i18n.button.continueDesigning": "",
  "i18n.button.returnToHomePage": "",
  "i18n.button.deleteImage": "",
  "i18n.button.withoutPhoto": "",
  "i18n.button.withoutThisPhoto": "",
  "i18n.button.chooseNewImage": "",
  "i18n.button.chooseOtherPhoto": "",
  "i18n.button.retryPhoto": "",
  "i18n.button.reload": "",
  "i18n.button.restartDesigner": "",
  "i18n.button.restart": "",
  "i18n.button.puzzleYouShop": "",
  "i18n.button.shop": "",
  "i18n.button.changeProduct": "",
  "i18n.button.keepProduct": "",
  "i18n.toggle.hidePuzzleOverlay": "",
  "i18n.toggle.showPuzzleOverlay": "",
  "i18n.toggle.hide": "",
  "i18n.toggle.showUsedImages": "",
  "i18n.toggle.hideUsedImages": "",
  "i18n.imagePromoter.title": "",
  "i18n.imagePromoter.content": "",
  "i18n.boxPromoter.title.puzzle": "",
  "i18n.boxPromoter.title.memo": "",
  "i18n.boxPromoter.title.default": "",
  "i18n.boxPromoter.content.designsAndText": "",
  "i18n.boxPromoter.content.designs": "",
  "i18n.boxPromoter.content.text": "",
  "i18n.control.colorChooser.matchingColors": "",
  "i18n.control.colorChooser.allColors": "",
  "i18n.control.colorChooser.allBgColors": "",
  "i18n.control.colorChooser.lowContrastHint": "",
  "i18n.control.fontChooser.group.classic": "",
  "i18n.control.fontChooser.group.creative": "",
  "i18n.control.fontChooser.group.handwritten": "",
  "i18n.control.fontChooser.group.modern": "",
  "i18n.control.fontChooser.group.technical": "",
  "i18n.control.imageQuality.title.good": "",
  "i18n.control.imageQuality.title.medium": "",
  "i18n.control.imageQuality.title.bad": "",
  "i18n.control.imageQuality.content.good": "",
  "i18n.control.imageQuality.content.medium": "",
  "i18n.control.imageQuality.content.bad": "",
  "i18n.control.imageQuality.affectedImages": [
    "",
    ""
  ],
  "i18n.control.imageQuality.showIndicators": "",
  "i18n.control.imageQuality.hideIndicators": "",
  "i18n.control.imageZoom.zoom": "Zoom:",
  "i18n.control.textEditing.menu.fonts": "",
  "i18n.control.textEditing.menu.effects": "",
  "i18n.control.textEditing.menu.colors": "",
  "i18n.control.textEditing.menu.bgColors": "",
  "i18n.control.textEditing.rejectMessage.characterWontFit": "Para melhor legibilidade, por favor reduz o comprimento do texto / número de caracteres por linha.",
  "i18n.control.textEditing.rejectMessage.fontFamilyTooLarge": "O tipo de letra escolhido é demasiado grande para este texto.",
  "i18n.control.textEditing.rejectMessage.fontSizeTooLarge": "O tamanho máximo de letra possível para este texto foi selecionado.",
  "i18n.control.textEditing.rejectMessage.fontSizeTooSmall": "O tamanho mínimo de letra possível foi selecionado.",
  "i18n.control.textEditing.rejectMessage.insertLineBreak": "Por favor, insere uma quebra de linha.",
  "i18n.control.textEditing.rejectMessage.insertLineBreakOrResizeTextField": "Por favor, insere uma quebra de linha ou aumenta o campo de texto.",
  "i18n.control.textEditing.rejectMessage.invalidCharacters": "Por favor, verifica os teus dados, nem todos os caracteres são suportados por este tipo de letra.",
  "i18n.control.textEditing.rejectMessage.maxCharactersReached": "",
  "i18n.control.textEditing.rejectMessage.maxLinesReached": "Foi atingido o número máximo de linhas.",
  "i18n.control.textEditing.rejectMessage.resizeTextField": "Por favor, aumenta o campo de texto.",
  "i18n.dialog.closeDesigner.message": "",
  "i18n.dialog.closeDesigner.title": "",
  "i18n.dialog.deletePlaceholder.message": "Este passo não pode ser anulado.",
  "i18n.dialog.deletePlaceholder.title": "Tem a certeza que quer eliminar o marcador de posição?",
  "i18n.dialog.deleteGalleryImage.title": "",
  "i18n.dialog.deleteGalleryImage.message": "",
  "i18n.dialog.insufficientImageQuality.message": "A resolução desta imagem é demasiado baixa para uma impressão ideal da imagem!",
  "i18n.dialog.smartSorted.message": "Com o SMART SORTED, montam a vossa imagem de 1000 peças de forma inovadora e sem esforço, mesmo sem modelo da imagem",
  "i18n.dialog.smartSorted.title": "Sucesso garantido no puzzle",
  "i18n.dialog.unchangedPlaceholders.boxTitle.message": "Por favor, clica em „{{text}}“ para personalizar o título ao teu gosto.",
  "i18n.dialog.unchangedPlaceholders.boxTitle.title": "O título da caixa não foi alterado.",
  "i18n.dialog.unchangedPlaceholders.buttons.addTitle.label": "",
  "i18n.dialog.unchangedPlaceholders.buttons.clear.label": "Continuar sem texto",
  "i18n.dialog.unchangedPlaceholders.image.message": [
    "",
    ""
  ],
  "i18n.dialog.unchangedPlaceholders.image.title": [
    "",
    ""
  ],
  "i18n.dialog.unchangedPlaceholders.message": [
    "Um marcador de posição não foi alterado.",
    "Vários marcadores de posição não foram alterados."
  ],
  "i18n.dialog.unchangedPlaceholders.text.message": [
    "",
    ""
  ],
  "i18n.dialog.unchangedPlaceholders.text.title": [
    "",
    ""
  ],
  "i18n.dialog.unchangedPlaceholders.title": "marcadores de posição não alterados",
  "i18n.dialog.productChooserWarning.title": "",
  "i18n.dialog.productChooserWarning.message": "",
  "i18n.dialog.imageQuality.title": "",
  "i18n.dialog.imageQuality.indicator.good": "",
  "i18n.dialog.imageQuality.indicator.medium": "",
  "i18n.dialog.imageQuality.indicator.bad": "",
  "i18n.dialog.imageQuality.subtitle.good": "",
  "i18n.dialog.imageQuality.subtitle.medium": "",
  "i18n.dialog.imageQuality.subtitle.bad": "",
  "i18n.dialog.imageQuality.content.good": "",
  "i18n.dialog.imageQuality.content.medium": "",
  "i18n.dialog.imageQuality.content.bad": "",
  "i18n.error.deprecatedBrowserError.message": "",
  "i18n.error.deprecatedBrowserError.title": "",
  "i18n.error.designerExpiredError.message": "Interrompeste a personalização por um longo período. Não é possível continuar. Por favor, inicia o processo novamente.",
  "i18n.error.designerExpiredError.title": "",
  "i18n.error.fontLoadingError.message": "",
  "i18n.error.fontLoadingError.title": "",
  "i18n.error.imageLoadingError.message": "Não foi possível carregar uma imagem.\nFoi removida da galeria e da área de design.",
  "i18n.error.imageLoadingError.title": "Erro de carregamento",
  "i18n.error.imageProvisionError.message": "Uma ou mais imagens não puderam ser processadas. Talvez o formato não seja suportado.",
  "i18n.error.imageProvisionError.title": "",
  "i18n.error.imageSelectionError.message": "O ficheiro „{{reference1}}“ não pôde ser processado.",
  "i18n.error.imageSelectionError.title": "Erro ao carregar a imagem",
  "i18n.error.imageSizeLimitExceededError.message": "A imagem que carregaste tem dimensões demasiado grandes.\nPor razões técnicas, não conseguimos processá-la.\nPor favor, reduz a imagem para menos de 180 megapixels e volta a carregá-la.",
  "i18n.error.imageSizeLimitExceededError.title": "Erro ao carregar a imagem",
  "i18n.error.imageUploadError.message": "Parece haver um problema com a ligação à Internet.\nPor favor, tenta novamente mais tarde.",
  "i18n.error.imageUploadError.title": "Erro ao carregar a imagem",
  "i18n.error.inlineSVGLoadingError.message": "",
  "i18n.error.inlineSVGLoadingError.title": "",
  "i18n.error.invalidCharConfigError.message": "A fonte está incorreta e não pode ser utilizada.",
  "i18n.error.invalidCharConfigError.title": "Fonte incorreta",
  "i18n.error.malformedProductError.message": "",
  "i18n.error.malformedProductError.title": "",
  "i18n.error.notInStockError.message": "",
  "i18n.error.notInStockError.title": "",
  "i18n.error.offlineNotice": "A tua ligação à Internet parece estar interrompida. Podes continuar a personalizar assim que a ligação for restabelecida.",
  "i18n.error.templateLoadingError.message": "O modelo „{{ error.reference[0] }}“ não pôde ser carregado.\nPor favor, tenta novamente mais tarde.",
  "i18n.error.templateLoadingError.title": "Erro de carregamento",
  "i18n.error.traudlLoadingError.message": "",
  "i18n.error.traudlLoadingError.title": "",
  "i18n.error.unsupportedMediaTypeError.message": "Formato de imagem não suportado para „{{reference1}}“.",
  "i18n.error.unsupportedMediaTypeError.title": "Erro ao carregar a imagem",
  "i18n.error.uploadProductError.message": "Um ou mais produtos não puderam ser transferidos para o servidor.\nÉ possível que haja um problema com a ligação à Internet.",
  "i18n.error.uploadProductError.title": "Erro de transmissão",
  "i18n.error.zoomModeError.message": "O teu texto do design anterior não pôde ser transferido e foi reiniciado.",
  "i18n.error.zoomModeError.title": "Texto não aplicado",
  "i18n.gallery.uploadPhotos.title": "",
  "i18n.gallery.uploadPhotos.message": "",
  "i18n.gallery.placedAllPhotos.title": "",
  "i18n.gallery.placedAllPhotos.message": "",
  "i18n.price.price": "Preço",
  "i18n.price.reduction": "Poupas",
  "i18n.price.total": "Preço total",
  "i18n.priceDisplay.times": [
    "{{value}} unidades a {{pricePerUnit}}",
    "{{value}} unidades a {{pricePerUnit}}"
  ],
  "i18n.progress.stepAdditionalProducts": "Escolher acessórios",
  "i18n.progressOverlay.message.lines.one": "Obrigado pela excelente personalização.",
  "i18n.progressOverlay.message.lines.two": "Estamos a preparar tudo para ti...",
  "i18n.template.insertText": "Introduzir texto aqui",
  "i18n.toolbox.image.title": "Editar imagem",
  "i18n.toolbox.layout.template.count": [
    "",
    ""
  ],
  "i18n.toolbox.layout.template.inUse": "",
  "i18n.toolbox.layout.template.suitableFor": [
    "1 imagem",
    "{{value}} imagens"
  ],
  "i18n.toolbox.layout.title": "",
  "i18n.toolbox.layout.titleBox": "",
  "i18n.toolbox.preview.title": "Pré-visualização 3D",
  "i18n.toolbox.productChooser.title": "Mudar produto",
  "i18n.toolbox.productChooser.triggerText": "Produto",
  "i18n.toolbox.productChooser.contentMessage.one": "",
  "i18n.toolbox.productChooser.contentMessage.two": "",
  "i18n.toolbox.textEdit.title": "",
  "i18n.toolbox.textEdit.noPlaceholdersTitle": "",
  "i18n.toolbox.textEdit.noPlaceholdersMessage": "",
  "i18n.toolbox.textEdit.noPlaceholdersButton": "",
  "i18n.toolbox.text.title": "Editar texto",
  "i18n.toolbox.imageEdit.title": "",
  "i18n.toolbox.imageEdit.removeImageMobile": "",
  "i18n.toolbox.imageEdit.removeImageDesktop": "",
  "i18n.toolbox.imageEdit.swapImage": ""
};


export class LocalePtPT {
  public getPlural(n: number): number
  {
    const pluralForm = (n != 1);
    if (typeof(pluralForm) === 'boolean') {
      return pluralForm ? 1 : 0;
    }
    return pluralForm;
  }
  public getTranslations(): any
  {
    return TRANSLATIONS;
  }
}
/* tslint:enable */
